import React, {ReactElement, useEffect, useState} from 'react';
import CouponsEmptyIcon from '../../../assets/images/coupons_empty.svg';

const EmptyCoupon: React.FC = (): ReactElement => {
  return (
    <div className="px-4 pb-4">
      <div className="pt-4 font-roboto text-xl">
        Select your exclusive coupon
      </div>
      <div className="flex place-content-center py-4">
        <img src={CouponsEmptyIcon} />
      </div>
      <div className="pt-4 font-roboto font-medium text-xl">We’re sorry!</div>
      <div className="pt-4 font-roboto flex flex-col text-black text-opacity-50 leading-5">
        <span>No offers available.</span>
        <span> Scan QR codes and unlock offers.</span>
      </div>
    </div>
  );
};
export default EmptyCoupon;
